import { render, staticRenderFns } from "./PricesCard.vue?vue&type=template&id=082093d0&"
import script from "./PricesCard.vue?vue&type=script&lang=js&"
export * from "./PricesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports